import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'oidc-client';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { SenderIdService } from './senderid.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private user: User;

  constructor(
    private auth: AuthService,
    private senderIdService: SenderIdService,
  ) {
    auth.userLoadedEvent.subscribe((user: User) => {
      this.user = user;
    });

    if (auth.currentUser) {
      this.user = auth.currentUser;
    }
  }

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    let authReq;
    let modifiedReq;

    if (req.headers.has('Authorization')) {
      authReq =
        req.headers.get('Authorization') === 'none'
          ? req.clone({
              headers: req.headers.delete('Authorization'),
            })
          : req;
    } else {
      authReq = this.user
        ? req.clone({
            headers: req.headers.append(
              'Authorization',
              `${this.user.token_type} ${this.user.access_token}`,
            ),
          })
        : req;
    }

    const senderId = this.senderIdService.getCurrentUserUUID;

    if (senderId && ['POST', 'PATCH', 'PUT'].indexOf(req.method) !== -1) {
      modifiedReq = authReq.clone({
        headers: authReq.headers.set('sender-id', senderId),
      });
    }

    return next
      .handle(modifiedReq ?? authReq)
      .pipe(catchError((err) => this.sessionChecker(err)));
  }

  private sessionChecker(err: unknown) {
    if (err instanceof HttpErrorResponse && err.status === 401) {
      this.auth.checkSession();
    }

    return throwError(err);
  }
}
